<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header-bg-variant="primary">
            <iframe
              width="100%"
              height="860"
              type="application/vnd.ms-excel"
              src="data:application/pdf;base64, "
              frameborder="0"
              :src="this.srcxls"
              allowfullscreen
            ></iframe>
<!--            :src="this.srcpdf"-->
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal
      title="You didn’t fill your information completely"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{current_erorrtxt }}</b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "CreateGeneral",
  data() {
    return {
      student:{},
      selected: "",
      sex: "",
      thai_student: "",
      current_erorrtxt: "",
      dangerModal: false,
      current_questionid: "",
      current_questionname: "",
      current_ansnumber: "",
      current_ans: "",
      i: 0,
      items: [],
      srcpdf: "",
      srcxls:""
    };
  },
  methods: {
    getExcel(thaistudent,faculty,dept,group,year) {
      api
        .getExcelNotRegis(thaistudent,faculty,dept,group,year)
        .then(res => {
          // console.log("res", res);
          this.srcxls = "data:application/vnd.ms-excel;base64, " + res.data.data;
          // this.srcpdf = "data:application/pdf;base64, " + res.data.data;
          // console.log(this.srcpdf);
        })
        .catch(err => {
          console.log("getExcelCompleted", err.toString());
          // if (this.year=='2562') {
          //   this.$router.push("/Login_62");
          // }
          // else if (this.year=='2563') {
          //   this.$router.push("/Login_63");
          // }
          return 0;
        });
    }
  },
  mounted() {},
  created() {

    if (!Number.isInteger(this.facultyid)){
      this.facultyid=0;
    }else{
      this.facultyid = parseInt(this.$route.query.id);
    }
    api.onSetHeader();
    this.facultyid = parseInt(this.$route.query.id);
    this.levelid = parseInt(this.$route.query.level);
    this.deptid = parseInt(this.$route.query.dept);
    this.groupid = parseInt(this.$route.query.group);
    this.year = parseInt(this.$route.query.year);
    // console.log("facultyid==",this.facultyid,this.levelid,this.year)
   // if (Number.isInteger(this.facultyid)) {
      // console.log("1")
      this.getExcel(2, this.facultyid, this.deptid, this.groupid, this.year);
     // this.$router.push("/Reportcompleted?year="+this.year+"&level="+this.levelid+"&id="+this.facultyid+"&dept="+this.deptid+"&group="+this.groupid);
    //}
    // this.actionUpdate = this.getCurrentStudent(this.student);
    // if (this.$store.state.token == null || this.$store.state.user == null) {
    //   if (this.year=='2562') {
    //     this.$router.push("/Login_62");
    //   }
    //   else if (this.year=='2563') {
    //     this.$router.push("/Login_63");
    //   }
    // } else {
    //   // this.$router.push("/Dashboard");
    // }

  }
};
</script>
<style>
</style>
